export enum PromoClaimRateIndicator {
  GREEN = 'GREEN',
  AMBER = 'AMBER',
  RED = 'RED',
}

export interface PromoClaimRateRowData {
  details?: {
    playerId?: number;
  };
}

export enum PromoClaimRateTrigger {
  AUTOMATED = 'Automated',
  MANUAL = 'Manual',
}

export interface PromoClaimRateCalculatedDTO {
  indicator: PromoClaimRateIndicator;
  claimRatePercentage: number;
  depositsCount: number;
  qualifiedPromotionsCount: number;
  dateUpdated: string;
}

export interface PromoClaimRateOverrideDTO {
  indicator: PromoClaimRateIndicator;
  reason: string;
  authorEmail: string;
  dateCreated: string;
}

export interface PromoClaimRateDTO {
  playerId: number;
  indicator: PromoClaimRateIndicator;
  overridden: boolean;
  calculated?: PromoClaimRateCalculatedDTO;
  override?: PromoClaimRateOverrideDTO;
}

export interface OverridePromoClaimRateRequest {
  indicator: PromoClaimRateIndicator;
  reason: string;
}

export interface CancelPromoClaimRateOverrideRequest {
  reason: string;
}

export const PROMO_CLAIM_RATE_INDICATOR_DESCRIPTIONS: Record<PromoClaimRateIndicator, string> = {
  [PromoClaimRateIndicator.GREEN]: 'Player has balanced play between promo incentivised activity and normal activity',
  [PromoClaimRateIndicator.AMBER]:
    'Player has a high level of promo incentivised activity, but this is alongside normal activity',
  [PromoClaimRateIndicator.RED]: 'Player’s activity is largely linked to promo incentivisation',
};
